<template>
  <div>
    <el-dialog v-if="mode === 'inspect'" title="处理报修" :visible.sync="dialogVisible" width="680px" append-to-body :close-on-click-modal="false">
      <el-alert type="info" :closable="false" show-icon title="请先完整记录本次维修情况；确认无法继续使用时，可在页面下方申请报废审批。" />
      <el-form ref="inspectForm" :model="inspectForm" label-width="96px" class="dialog-form">
        <el-form-item label="报修资产">{{ record.assetCodeSnapshot }} / {{ record.assetNameSnapshot }}</el-form-item>
        <el-form-item label="报修信息">{{ damageText(record.damageLevel) }}；{{ record.faultDescription }}</el-form-item>
        <el-row :gutter="14">
          <el-col :span="12"><el-form-item label="维修日期" required><el-date-picker v-model="inspectForm.repairDate" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="维修费用"><el-input-number v-model="inspectForm.repairCost" :min="0" :precision="2" controls-position="right" style="width:100%" /></el-form-item></el-col>
        </el-row>
        <el-form-item label="维修方式" required><el-input v-model="inspectForm.repairMethod" maxlength="200" placeholder="如：内部检修、外送维修、更换部件" /></el-form-item>
        <el-form-item label="维修结果" required><el-input v-model="inspectForm.repairResult" type="textarea" :rows="3" maxlength="1000" show-word-limit placeholder="填写维修过程及结论；如无法修复，请说明检测结果" /></el-form-item>
        <el-form-item label="维修附件"><file-upload v-model="inspectFiles" :limit="6" :multiple="true" /></el-form-item>
        <el-form-item :label="inspectForm.scrapRequested ? '报废原因' : '处理说明'" :required="inspectForm.scrapRequested"><el-input v-model="inspectForm.inspectionRemark" type="textarea" :rows="3" maxlength="1000" show-word-limit :placeholder="inspectForm.scrapRequested ? '请说明无法修复、维修价值过低或存在安全风险等原因' : '可填写补充说明'" /></el-form-item>
        <el-form-item label-width="0" class="scrap-option">
          <el-checkbox v-model="inspectForm.scrapRequested"><strong>维修后仍无法正常使用，申请报废审批</strong></el-checkbox>
          <div class="scrap-tip">勾选后会先保存本次维修记录，再发起报废审批；审批通过并登记处置后才正式报废。</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitInspect">{{ inspectForm.scrapRequested ? '保存维修记录并发起报废审批' : '保存维修记录' }}</el-button>
      </div>
    </el-dialog>

    <el-dialog v-else title="登记报废处置结果" :visible.sync="dialogVisible" width="680px" append-to-body :close-on-click-modal="false">
      <el-alert type="success" :closable="false" show-icon title="报废审批已通过。完成处置登记后，资产才正式变为“已报废”。" />
      <el-form ref="disposalForm" :model="disposalForm" :rules="disposalRules" label-width="96px" class="dialog-form">
        <el-form-item label="报废资产">{{ record.assetCodeSnapshot }} / {{ record.assetNameSnapshot }}</el-form-item>
        <el-row :gutter="14">
          <el-col :span="12"><el-form-item label="处置日期" prop="disposalDate"><el-date-picker v-model="disposalForm.disposalDate" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="处置方式" prop="disposalMethod"><el-select v-model="disposalForm.disposalMethod" allow-create filterable style="width:100%"><el-option label="废品回收" value="废品回收" /><el-option label="交由专业机构处置" value="交由专业机构处置" /><el-option label="无残值销毁" value="无残值销毁" /><el-option label="其他" value="其他" /></el-select></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="处置收入"><el-input-number v-model="disposalForm.disposalAmount" :min="0" :precision="2" controls-position="right" style="width:100%" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="处置单位"><el-input v-model="disposalForm.disposalCounterparty" maxlength="200" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="处置单据"><file-upload v-model="disposalFiles" :limit="8" :multiple="true" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="处置说明"><el-input v-model="disposalForm.remark" type="textarea" :rows="3" maxlength="1000" show-word-limit /></el-form-item></el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitDisposal">确认完成处置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/views/crm/components/fileUpload'
import { inspectAssetRepair, completeAssetDisposal } from '@/api/crm/asset'

const today = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

const emptyInspectForm = () => ({ recordId: null, decision: 'REPAIR', scrapRequested: false, inspectionRemark: '', repairDate: today(), repairMethod: '', repairResult: '', repairCost: null, repairFileObjs: '' })
const emptyDisposalForm = () => ({ recordId: null, disposalDate: today(), disposalMethod: '', disposalAmount: null, disposalCounterparty: '', disposalFileObjs: '', remark: '' })

export default {
  name: 'AssetRepairProcessDialog',
  components: { FileUpload },
  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: 'inspect' },
    record: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      submitting: false,
      inspectFiles: [],
      disposalFiles: [],
      inspectForm: emptyInspectForm(),
      disposalForm: emptyDisposalForm(),
      disposalRules: {
        disposalDate: [{ required: true, message: '请选择处置日期', trigger: 'change' }],
        disposalMethod: [{ required: true, message: '请选择或填写处置方式', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(value) { this.$emit('update:visible', value) }
    }
  },
  watch: {
    visible(value) {
      if (value) this.resetForm()
    }
  },
  methods: {
    resetForm() {
      this.inspectFiles = []
      this.disposalFiles = []
      this.inspectForm = Object.assign(emptyInspectForm(), { recordId: this.record.id })
      this.disposalForm = Object.assign(emptyDisposalForm(), { recordId: this.record.id })
      this.$nextTick(() => {
        const form = this.mode === 'inspect' ? this.$refs.inspectForm : this.$refs.disposalForm
        if (form) form.clearValidate()
      })
    },
    submitInspect() {
      if (!this.inspectForm.repairDate) return this.msgError('请选择维修日期')
      if (!String(this.inspectForm.repairMethod || '').trim()) return this.msgError('请填写维修方式')
      if (!String(this.inspectForm.repairResult || '').trim()) return this.msgError('请填写维修结果')
      if (this.inspectForm.scrapRequested && !String(this.inspectForm.inspectionRemark || '').trim()) return this.msgError('请填写报废原因')
      const data = Object.assign({}, this.inspectForm, { decision: this.inspectForm.scrapRequested ? 'SCRAP' : 'REPAIR', repairFileObjs: JSON.stringify(this.inspectFiles || []) })
      delete data.scrapRequested
      this.submitting = true
      inspectAssetRepair(data).then(() => {
        this.msgSuccess(data.decision === 'SCRAP' ? '报废审批已发起' : '维修记录已完成')
        this.dialogVisible = false
        this.$emit('success')
      }).finally(() => { this.submitting = false })
    },
    submitDisposal() {
      this.$refs.disposalForm.validate(valid => {
        if (!valid) return
        const data = Object.assign({}, this.disposalForm, { disposalFileObjs: JSON.stringify(this.disposalFiles || []) })
        this.submitting = true
        completeAssetDisposal(data).then(() => {
          this.msgSuccess('处置已登记，资产已正式报废')
          this.dialogVisible = false
          this.$emit('success')
        }).finally(() => { this.submitting = false })
      })
    },
    damageText(value) {
      return ({ 10: '轻微', 20: '中度', 30: '严重', 40: '报废' })[Number(value)] || '-'
    }
  }
}
</script>

<style scoped>
.dialog-form { margin-top:16px; }
.scrap-option { margin-top:8px; padding:14px 16px; background:#f5f7fa; border-top:1px solid #ebeef5; }
.scrap-tip { margin:6px 0 0 25px; color:#909399; font-size:12px; line-height:1.5; }
</style>
